import { ValidatorRuleType } from "@sunSource/Common/Utilities/validate";

export const intialErrorFormState = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    companyName: "",
    jobTitle: "",
    addressLineOne: "",
    city: "",
    state: "",
    zipCode: "",
    password: "",
    confirmPassword: "",
    billToAddressLineOne: "",
    billToCity: "",
    billToState: "",
    billToZipCode: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const newCustomerValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        label: "First Name",
    },
    lastName: {
        required: true,
        minLength: 2,
        label: "Last Name",
    },
    companyName: {
        required: true,
        minLength: 2,
        label: "Company Name",
    },
    city: {
        required: true,
        minLength: 2,
        label: "City",
    },
    zipCode: {
        required: true,
        maxLength: 5,
        label: "Zip Code",
        maxLengthMsg: "Please Enter Valid Zip Code",
    },
    addressLineOne: {
        required: true,
        minLength: 2,
        label: "Address Line One",
    },
    email: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "Email Address",
    },
    phoneNumber: {
        required: true,
        label: "Phone Number",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Phone Number",
    },
    fax: {
        label: "Fax",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Fax Number",
    },
    jobTitle: {
        required: true,
        minLength: 2,
        label: "Job Title",
    },
    state: {
        required: true,
        label: "State Name",
    },
    billToAddressLineOne: {
        required: true,
        minLength: 2,
        label: "Address Line One",
    },
    billToCity: {
        required: true,
        minLength: 2,
        label: "City",
    },
    billToState: {
        required: true,
        label: "State Name",
    },
    billToZipCode: {
        required: true,
        maxLength: 5,
        label: "Zip Code",
        maxLengthMsg: "Please Enter Valid Zip Code",
    },
};
